/**
 * The single list of site designs. Shared by the Panda config (build time) and the app (runtime),
 * so it must stay free of React and browser code. See ./README.md for how to add one.
 */
export const DESIGN_IDS = ['storybook', 'nebula'] as const;

export type DesignId = (typeof DESIGN_IDS)[number];

/** Shown to first-time visitors and to crawlers. */
export const DEFAULT_DESIGN: DesignId = 'storybook';

/** Set on <html>; every design-scoped token and style keys off it. */
export const DESIGN_ATTRIBUTE = 'data-design';

/** localStorage key that remembers the visitor's choice */
export const DESIGN_STORAGE_KEY = 'shaojiang-design';

/** `?design=nebula` opens the site in that design (handy for sharing a look). */
export const DESIGN_QUERY_PARAM = 'design';

/** Marks markup that only belongs to some designs (`<DesignOnly>`), hidden by CSS otherwise. */
export const DESIGN_ONLY_ATTRIBUTE = 'data-design-only';

export const isDesignId = (value: unknown): value is DesignId =>
  typeof value === 'string' && (DESIGN_IDS as readonly string[]).includes(value);

/** Panda condition for a design, e.g. `_nebula: { ... }` in any style object. */
export const designCondition = (id: DesignId) => `[${DESIGN_ATTRIBUTE}=${id}] &`;
